export default __webpack_public_path__ + "static/media/Assessment_header.57b2672e.svg";